// types
import { MenuProps } from '@/types/menu';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

// initial state
const initialState: MenuProps = {
    selectedItem: ['dashboard'],
    selectedID: null,
    drawerOpen: true
};

// ==============================|| SLICE - MENU ||============================== //

const menu = createSlice({
    name: 'menu',
    initialState,
    reducers: {
        activeItem(state, action: PayloadAction<string[]>) {
            state.selectedItem = action.payload;
        },

        activeID(state, action: PayloadAction<string | null>) {
            state.selectedID = action.payload;
        },

        openDrawer(state, action: PayloadAction<boolean>) {
            state.drawerOpen = action.payload;
        }
    }
});

export default menu.reducer;

export const { activeItem, openDrawer, activeID } = menu.actions;
